import { ThemeType } from './types';

export const defaultTheme: ThemeType = {
  base: 'light',
  brandTitle: 'Storybook Pickit',
  brandUrl: '/',
  brandImage: '../assets/PICKIT_NARANJA.svg',
  brandTarget: '_self',
  userLogoName: 'pickit-user',
  grayA9: '#A9A9A9',
  gray2D: '#2D2D2D',
  gray4D: '#4D4D4D',
  gray80: '#808080',
  grayB8: '#B8B8B8',
  grayCC: '#CCCCCC',
  grayC4: '#C4C4C4',
  grayC4Trans: '#C4C4C4C0',
  blackTrans: '#00000040',
  grayF0: '#F0F0F0',
  grayF5: '#F5F5F5',
  white: '#FFFFFF',
  black: '#000000',
  blue: '#0098FF',
  overlayBlack: '#2D2D2D80',
  layers: {
    baseLayer: 0,
    intermediateBaseLayer: 50,
    intermediateMediumLayer: 75,
    mediumLayer: 100,
    intermediateTopLayer: 150,
    topLayer: 200,
  },
  basicIcon: {
    small: {
      size: 16,
    },
    medium: {
      size: 24,
    },
    large: {
      size: 32,
    },
    'tab-size-large': {
      size: 54,
    },
    'tab-size-medium': {
      size: 48,
    },
  },
  complexIcon: {
    'extra-small': {
      size: 48,
    },
    small: {
      size: 56,
    },
    medium: {
      size: 64,
    },
    large: {
      size: 72,
    },
    'extra-large': {
      size: 96,
    },
    'tab-size-large': {
      size: 54,
    },
    'tab-size-medium': {
      size: 48,
    },
  },
  stepper: {
    success: {
      color: '#04CE6D',
      pipeColor: '#04CE6D',
      opacity: '#E6FAF0',
    },
    error: {
      color: '#FF1515',
      pipeColor: '#FF1515',
      opacity: '#FFE8E8',
    },
    actual: {
      color: '#04CE6D',
      pipeColor: '#B8B8B8',
      opacity: '#F0F0F0',
    },
    next: {
      color: '#b8b8b8',
      pipeColor: '#B8B8B8',
      opacity: '#F0F0F0',
    },
  },
  status: {
    default: {
      default: '#FF6C0E', // background
      hover: '#DB5600', // hover
      active: '#A84200', // active/pressed
      background: '#FFF0E7', // focus
    },
    success: {
      default: '#04CE6D',
      hover: '#039B52',
      active: '#026938',
      background: '#E6FAF0',
    },
    info: {
      default: '#338AF3',
      hover: '#0E70E7',
      active: '#0B59B7',
      background: '#EBF3FE',
    },
    warning: {
      default: '#FFA825',
      hover: '#F09000',
      active: '#BD7100',
      background: '#FFF6E9',
    },
    error: {
      default: '#FF1515',
      hover: '#E00000',
      active: '#AD0000',
      background: '#FFE8E8',
    },
    disabled: {
      default: '#B8B8B8',
      color: '#CCCCCC',
      background: '#F0F0F0',
      contrast: '#FFFFFF',
      hover: '#2D2D2D',
      active: '#2D2D2D',
      opacity: '#F0F0F0',
      border: '#2D2D2D',
    },
    context: {
      default: '#63187D',
      hover: '#4F1466',
      active: '#3D0F4D',
      background: '#FAEAFF',
    },
  },
  alerts: {
    success: '#04CE6D',
    error: '#FF1515',
    warning: '#FFA825',
    info: '#338AF3',
  },
  button: {
    mobileFontSize: 12,
    sizes: {
      small: {
        fontSize: 14,
        lineHeight: 18,
        height: 32,
        padding: 22,
        spinner: 14,
        circularPadding: 6,
      },
      medium: {
        fontSize: 16,
        lineHeight: 20,
        height: 40,
        padding: 24,
        spinner: 16,
        circularPadding: 8,
      },
      large: {
        fontSize: 16,
        lineHeight: 20,
        height: 48,
        padding: 26,
        spinner: 20,
        circularPadding: 8,
      },
    },
    defaultLinkColor: '#00B2E3',
    hoverLinkColor: '#008CB2',
    activeLinkColor: '#006480',
  },
  datePicker: {
    default: '#FF6C0E',
    background: '#FFF0E7',
  },
  toast: {
    height: 50,
    types: {
      default: {
        backgroundColor: '#F0F0F0',
        iconColor: '#808080',
      },
      confirmation: {
        backgroundColor: '#e6faf0',
        iconColor: '#04CE6D',
      },
      success: {
        backgroundColor: '#e6faf0',
        iconColor: '#04CE6D',
      },
      alert: {
        backgroundColor: '#FFF6E9',
        iconColor: '#FFA825',
      },
      info: {
        backgroundColor: '#EBF3FE',
        iconColor: '#338AF3',
      },
      error: {
        backgroundColor: '#FFF3F3',
        iconColor: '#FF1515',
      },
    },
  },
  radiobutton: {
    sizes: {
      small: {
        outerCircle: 16,
        innerCircle: 8,
        border: 1,
        lineHeight: 16,
        fontSize: 14,
      },
      medium: {
        outerCircle: 20,
        innerCircle: 10,
        border: 1.5,
        lineHeight: 20,
        fontSize: 16,
      },
      large: {
        outerCircle: 26,
        innerCircle: 13,
        border: 2,
        lineHeight: 26,
        fontSize: 20,
      },
    },
  },
  sidebar: {
    background: '#FFFFFF',
    color: '#2D2D2D',
    node: {
      color: '#2D2D2D',
      active: '#FF6C0E',
    },
    item: {
      active: '#FF6C0E',
      color: '#2D2D2D',
    },
  },
  tooltip: {
    background: '#4d4d4d',
    color: '#ffffff',
    lineHeight: 18,
  },
  contextMenu: {
    color: '#4D4D4D',
    active: '#FF6C0E',
  },
  checkbox: {
    colors: {
      background: 'transparent',
    },
    sizes: {
      small: {
        box: 16,
        lineHeight: 16,
        fontSize: 14,
      },
      medium: {
        box: 18,
        lineHeight: 18,
        fontSize: 16,
      },
      large: {
        box: 24,
        lineHeight: 24,
        fontSize: 22,
      },
    },
  },
  collapsible: {
    duration: 350,
  },
  input: {
    sizes: {
      standard: {
        fontSize: 16,
        lineHeight: 20,
        height: {
          underline: 52,
          'contained-label': 56,
          'top-aligned-label': 48,
        },
        paddingBottom: 8,
      },
      small: {
        fontSize: 14,
        lineHeight: 18,
        height: {
          underline: 48,
          'contained-label': 52,
          'top-aligned-label': 44,
        },
        paddingBottom: 6,
      },
    },
    error: {
      background: '#FFF3F3',
      lineHeight: 16,
      fontSize: 12,
      containerHeight: 16,
    },
    spaceBetweenInputs: 8,
  },
  informationNotification: {
    default: {
      border: '#808080',
      background: '#F0F0F0',
    },
    success: {
      border: '#04CE6D',
      background: '#E6FAF0',
    },
    info: {
      border: '#338AF3',
      background: '#EBF3FE',
    },
    warning: {
      border: '#FFA825',
      background: '#FFF6E9',
    },
    error: {
      border: '#FF1515',
      background: '#FFF3F3',
    },
  },
  paginator: {
    active: '#FF6C0E',
    hover: '#DDDDDD',
  },
  tabs: {
    active: '#FF6C0E',
    disabled: '#b5b5b5',
    height: {
      minimal: 26,
      small: 40,
      medium: 60,
      large: 100,
    },
    width: 230,
    minimalWidth: 160,
    align: {
      left: 'flex-start',
      center: 'center',
    },
  },
  toggleSwitch: {
    toggled: {
      default: '#FF6C0E',
      success: '#04CE6D',
      info: '#338AF3',
      warning: '#FFA825',
      error: '#FF1515',
    },
    default: '#808080',
    disabled: '#b5b5b5',
    toggleSpan: '#F0F0F0',
  },
  modal: {
    padding: 16,
    animationDuration: 300,
  },
  table: {
    sizes: {
      small: {
        maxLines: 1,
        rowHeight: { small: 48, large: 60 },
        maxHeight: { small: '48px', large: '60px' },
      },
      medium: {
        maxLines: 2,
        rowHeight: { small: 60, large: 72 },
        maxHeight: { small: '60px', large: '72px' },
      },
      large: {
        maxLines: 3,
        rowHeight: { small: 72, large: 72 },
        maxHeight: { small: '72px', large: '72px' },
      },
      fullHeight: {
        maxLines: 3,
        rowHeight: { small: 72, large: 72 },
        maxHeight: { small: 'unset', large: 'unset' },
      },
    },
    fontSizes: {
      large: 16,
      small: 14,
    },
    viewMoreButton: {
      default: '#FF6C0E',
      disabled: '#b5b5b5',
    },
  },
  statusStepper: {
    success: '#04CE6D',
    cancel: '#FF1515',
    labelWidth: 278,
    scrollHeightOffSet: 20,
    scrollActionHeightOffSet: 16,
    isExpandibleHeight: 60,
    defaultHeight: 24,
    singleLineHeight: 40,
    lineHeight: 20,
    buttonOffSet: 16,
  },
  loadBar: {
    progress: { primary: '#FF6C0E', secondary: '#00B2E3' },
    uncompleted: '#ccc',
  },
  navbar: {
    dark: '#000000',
    light: '#FF6C0E',
  },
};

export const pickitTheme: ThemeType = {
  ...defaultTheme,
  base: 'light',
  brandTitle: 'Storybook Pickit',
  brandUrl: '/',
  brandImage: '../assets/PICKIT_NARANJA.svg',
  brandTarget: '_self',
};

export const pickersTheme: ThemeType = {
  ...defaultTheme,
  base: 'light',
  brandTitle: 'Storybook Pickit',
  brandUrl: '/',
  brandImage: '../assets/PICKIT_NARANJA.svg/MarcasDesktop.svg',
  brandTarget: '_self',
  userLogoName: 'picker-user',
  status: {
    ...defaultTheme.status,
    default: {
      opacity: '#EBF3FE',
      default: '#0098ff', // background
      hover: '#0E70E7', // hover
      active: '#0B59B7', // active/pressed
      background: '#E6F5FF', // focus
    },
  },
  datePicker: {
    default: '#0098ff',
    background: '#E6F5FF',
  },
  sidebar: {
    background: '#FFFFFF',
    color: '#2D2D2D',
    node: {
      color: '#2D2D2D',
      active: '#0098ff',
    },
    item: {
      active: '#0098ff',
      color: '#2D2D2D',
    },
  },
  contextMenu: {
    color: '#4D4D4D',
    active: '#0098ff',
  },
  paginator: {
    active: '#0098ff',
    hover: '#DDDDDD',
  },
  tabs: {
    ...defaultTheme.tabs,
    active: '#0098ff',
  },
  toggleSwitch: {
    toggled: {
      default: '#0098FF',
      success: '#04CE6D',
      info: '#338AF3',
      warning: '#FFA825',
      error: '#FF1515',
    },
    default: '#808080',
    disabled: '#b5b5b5',
    toggleSpan: '#F0F0F0',
  },
  table: {
    ...defaultTheme.table,
    viewMoreButton: {
      ...defaultTheme.table.viewMoreButton,
      default: '#0098ff',
    },
  },
  loadBar: {
    progress: { primary: '#0098ff', secondary: '#0098ff' },
    uncompleted: '#ccc',
  },
  navbar: {
    dark: '#000000',
    light: '#0098FF',
  },
};

export const StatusList = Object.keys(defaultTheme.status);
export const SizesList = Object.keys(defaultTheme.button.sizes);
export const InputSizesList = Object.keys(defaultTheme.input.sizes);
